import {helpdeskAxios} from '@/plugins/helpdeskAxios';
import {settings} from '@/plugins/settings';

// Per-user settings stored by the helpdesk (keyed by the mayordomo user of the JWT), so they
// survive logouts, other browsers and cleared storage. A key nobody saved yet comes back as null.

export const INBOX_FILTERS_KEY = 'inbox_filters';

export interface IInboxFilters {
  // Empty = "Todos".
  statuses: string[];
  // null = every Gmail account.
  account_id: number | null;
}

function url(key: string): string {
  return settings.helpdeskEndpoint + 'v1/me/preferences/' + encodeURIComponent(key);
}

// Response shape: {data: {key, value}}
const valueOf = (res: any) => (res.data && res.data.data && res.data.data.value !== undefined) ? res.data.data.value : null;

export function getPreference<T>(key: string): Promise<T | null> {
  return helpdeskAxios({url: url(key), method: 'GET'}).then(valueOf);
}

export function savePreference<T>(key: string, value: T): Promise<T | null> {
  return helpdeskAxios({url: url(key), method: 'PUT', data: {value}}).then(valueOf);
}

export function deletePreference(key: string): Promise<void> {
  return helpdeskAxios({url: url(key), method: 'DELETE'}).then(() => undefined);
}
